import axios from "axios";
import { api } from "~/router/apiConfig";

export function index(contractId) {
  return axios.get(
    api.path("contractBalance.index", { contractId: contractId })
  );
}

export function show(id, { estimate = false } = {}) {
  return axios.get(
    api.path("contractBalance.show", { id: id }),
    {
      params: estimate ? { estimate: true } : {}
    }
  );
}
